import React,{ useState,useEffect,useRef } from 'react'
import './select.scss'
import Image from '../Image'
import listenForOutsideClicks from '../../../utils/ListenForOutsideClick'

const Select = ({placeholder, search, options, label, defaultValue,onChange,nameKey, disabled}) => {
    const [open, setOpen] = useState(false)
    const [listening, setListening] = useState(false)
    const dropdownRef = useRef(), dropdownContainer= useRef(), inputRef=useRef()
    const [reformOption, setReformOption] = useState(options)
    useEffect(listenForOutsideClicks(listening, setListening, dropdownRef, setOpen))
    const dropdown = ()=>{
        let bounding = dropdownRef.current.getBoundingClientRect();
        let position = bounding.bottom> 500 && options.length ?"up":"down"
        setOpen(open?!open:position)
    }
    useEffect(()=>{
        inputRef.current.value = defaultValue?.[nameKey?nameKey:'name'] || ""
    },[defaultValue])
    useEffect(()=>{
        setReformOption(options || [])
    },[options])

  return (
    <div className='select-container' ref={dropdownRef}>
        {label && <label>{label}</label>}
        <div className='input' onClick={dropdown}>
            <input 
                placeholder={placeholder} 
                readOnly={!search} 
                ref={inputRef}
                disabled={disabled}
                // value={defaultValue?.[nameKey?nameKey:'name'] || ""}
                onChange={(e)=>{
                    let val = (e.target.value)
                    inputRef.current.value  = val
                    let arr 
                    if(val){
                        arr = [...options].filter(o=> {
                            let text = nameKey?o[nameKey]:o.name
                            if(text.toLowerCase().indexOf(val?.toLowerCase())>-1){
                                return o
                            }
                        })
                    }else{
                        arr = options
                    }
                    setReformOption(arr)
                    if(!val) onChange(val)
                    // search && onChange(val)
                }}
            />
            {/* {
                search ?(:)
            } */}
            <Image 
            src={`/images/icons/${search?'search':'chevron_down'}.svg`} />
        </div>
        {
            open  && (
                <ul className={`select-dropdown select-dropdown-${open}`} ref={dropdownContainer}>
                    
                    {
                        reformOption.length ? reformOption.map(o=>(
                        <li 
                        onClick={()=>{
                            onChange(o)
                            setOpen(false)
                        }}
                        className={`li ${defaultValue && (defaultValue[nameKey?nameKey:'name']===o[nameKey?nameKey:'name']) ?'li-selected':''}`}>{o[nameKey?nameKey:'name']}</li>)):(<li>-- 無資料 --</li>)
                    }
            </ul>
            )
        }
       
        
    </div>
  )
}

export default Select